import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ErrorResponse } from 'src/app/core/models/common.models';
import { CraftItem } from 'src/app/core/models/craft.models';
import { DBIdea } from 'src/app/core/models/idea.models';
import { CraftItemsBackendService } from 'src/app/core/services/backend/craft-items.backend.service';
import {
  IdeasReqLinkItemAction,
  IdeasReqLinkItemErrorAction,
  IdeasReqLinkItemSuccessAction,
  IdeasReqUnLinkItemAction,
  IdeasReqUnLinkItemErrorAction,
  IdeasReqUnLinkItemSuccessAction,
} from 'src/app/core/store/actions/ideas';
import { CoreState } from '../reducers';

@Injectable({
  providedIn: 'root',
})
export class IdeasLinkItemsStoreService {
  constructor(
    private store$: Store<CoreState>,
    private cibs: CraftItemsBackendService, //
  ) {}

  public linkItem(idea: DBIdea, itemId: string): Observable<void> {
    this.store$.dispatch(new IdeasReqLinkItemAction({ productId: idea.productId, ideaId: idea.id, itemId }));

    return this.cibs.linkItem(idea.productId, idea.id, itemId).pipe(
      map(() => {
        this.store$.dispatch(new IdeasReqLinkItemSuccessAction());
      }),
      catchError((err: ErrorResponse) => {
        this.store$.dispatch(new IdeasReqLinkItemErrorAction(err));
        return throwError(() => err);
      }),
    );
  }

  public promoteItem(idea: DBIdea, item: CraftItem): Observable<void> {
    this.store$.dispatch(new IdeasReqLinkItemAction({ productId: idea.productId, ideaId: idea.id, itemId: item.id }));

    return this.cibs.promoteIdea(item.id, idea).pipe(
      map(() => {
        this.store$.dispatch(new IdeasReqLinkItemSuccessAction());
      }),
      catchError((err: ErrorResponse) => {
        this.store$.dispatch(new IdeasReqLinkItemErrorAction(err));
        return throwError(() => err);
      }),
    );
  }

  public unlinkItem(idea: DBIdea, itemId: string): Observable<void> {
    this.store$.dispatch(new IdeasReqUnLinkItemAction({ productId: idea.productId, ideaId: idea.id, itemId }));

    return this.cibs.unlinkItem(idea.productId, idea.id, itemId).pipe(
      map(() => {
        this.store$.dispatch(new IdeasReqUnLinkItemSuccessAction());
      }),
      catchError((err: ErrorResponse) => {
        this.store$.dispatch(new IdeasReqUnLinkItemErrorAction(err));
        return throwError(() => err);
      }),
    );
  }
}
